import { useEffect } from 'react';
import useCoreStore from './coreStore';
import useProjectStore from './projectStore';

const cap = key => key.charAt(0).toUpperCase() + key.slice(1);

/**
 * Factory for useEnsure* hooks. All hooks have identical logic:
 * call ensureX() whenever projectId, cachedAt, or _invalidationSeq changes.
 *
 * Adding a new slice: export one more line at the bottom of this file.
 */
function makeEnsureHook(key) {
  return function useEnsureSlice() {
    const projectId = useProjectStore(s => s.currentProjectId);
    const cachedAt  = useCoreStore(s => s[`${key}CachedAt`]);
    const seq       = useCoreStore(s => s._invalidationSeq);
    useEffect(() => {
      if (!projectId) return;
      useCoreStore.getState()[`ensure${cap(key)}`]();
    }, [projectId, cachedAt, seq]);
  };
}

export const useEnsureHosts              = makeEnsureHook('hosts');
export const useEnsureApplications       = makeEnsureHook('applications');
export const useEnsureVulnerabilities    = makeEnsureHook('vulnerabilities');
export const useEnsureInstalledPackages  = makeEnsureHook('installedPackages');
export const useEnsureAssessmentsSummary = makeEnsureHook('assessmentsSummary');
export const useEnsureEnrichmentResults  = makeEnsureHook('enrichmentResults');
export const useEnsureAppGraphData       = makeEnsureHook('appGraphData');
